/** Apply a Deploy — a fresh 3-HP stack onto an own home cell (rule.md §6). */
import { STACK_HP } from "../data/constants";
import type { DeployAction } from "../types/action";
import type { AugmentedWarState, Unit } from "../types/game-state";
import { finalize, spendAction, updatePlayer } from "./shared";

export function applyDeploy(
  state: AugmentedWarState,
  action: DeployAction,
): AugmentedWarState {
  const board: Record<string, Unit> = { ...state.board };
  board[action.to] = { owner: action.playerId, hp: STACK_HP };
  const players = updatePlayer(state.players, action.playerId, {
    reserve: state.players[action.playerId].reserve - 1,
  });
  return finalize({
    ...state,
    board,
    players,
    ...spendAction(state, "deploy"),
  });
}
